import { initBasketDialog } from './retail/basket.js';
import { initNavigation } from './retail/navigation.js';

document.addEventListener('DOMContentLoaded', () => {
    initNavigation();
    initBasketDialog();
});
